import { render, staticRenderFns } from "./shippingMehtod.vue?vue&type=template&id=a59c5b36&scoped=true"
import script from "./shippingMehtod.vue?vue&type=script&lang=js"
export * from "./shippingMehtod.vue?vue&type=script&lang=js"
import style0 from "./shippingMehtod.vue?vue&type=style&index=0&id=a59c5b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c5b36",
  null
  
)

export default component.exports